import { SET_PARTNER_LINKS, SET_IS_NED_ACCOUNT, SET_INTEGRATION_SETTINGS, CLEAR } from "./actionTypes";
import { AccountIntegrationSettings, PartnerLink } from "../types";

const setPartnerLinks = (payload: PartnerLink[]) => ({
  type: SET_PARTNER_LINKS,
  payload,
});

const setIsNTPAccount = (payload: boolean) => ({
  type: SET_IS_NED_ACCOUNT,
  payload,
});

const setIntegrationSettings = (payload: AccountIntegrationSettings[]) => ({
  type: SET_INTEGRATION_SETTINGS,
  payload,
});

const clearState = () => ({
  type: CLEAR,
});

export const aftermarketPartnerActions = {
  setPartnerLinks,
  setIsNTPAccount,
  setIntegrationSettings,
  clearState,
};
